<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Empresas</h4>
    <hr />

    <DataTable
      :data="empresas"
      :columns="columnas"
      idField="idEmpresa"
      mensajeVacio="No hay empresas registradas."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idEmpresa)"
      @view="row => abrirEditar(row.idEmpresa)"
      @delete="row => deleteEmpresa(row.idEmpresa)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Localidad -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Localidad</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoEmpresa.idLocalidad">
                      <option disabled value="">Seleccione...</option>
                      <option
                        v-for="loc in localidads"
                        :value="loc.idLocalidad"
                        :key="loc.idLocalidad"
                      >
                        {{ loc.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Tipo Identificación + Documento -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Tipo Iden</label>
                  </div>
                  <div class="col-4">
                    <select class="form-select" v-model="datoEmpresa.idTipoIden">
                      <option disabled value="">Seleccione...</option>
                      <option
                        v-for="ti in tipoIdens"
                        :value="ti.idTipoIden"
                        :key="ti.idTipoIden"
                      >
                        {{ ti.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Documento</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEmpresa.documento"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Razón Social -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Razón Social</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEmpresa.razonSocial"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEmpresa.nombre"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre Corto -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre Corto</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEmpresa.nombreCorto"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Dirección -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Dirección</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      v-model="datoEmpresa.direccion"
                      style="text-transform:uppercase"
                      rows="2"
                    ></textarea>
                  </div>
                </div>
              </div>
              <!-- Teléfono -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Teléfono</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEmpresa.telefono"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Email -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Email</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="email"
                      class="form-control"
                      v-model="datoEmpresa.email"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Ciudad -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Ciudad</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEmpresa.ciudad"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Auditoría (solo edición) -->
              <div v-if="btnEditar">
                <hr />
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="form-label fw-bold">Usuario Reg.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoEmpresa.idUsuarioReg" disabled />
                    </div>
                    <div class="col-2"><label class="form-label fw-bold">Fecha Reg.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoEmpresa.fechaReg" disabled />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="form-label fw-bold">Usuario Act.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoEmpresa.idUsuarioAct" disabled />
                    </div>
                    <div class="col-2"><label class="form-label fw-bold">Fecha Act.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoEmpresa.fechaAct" disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarEmpresa"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarEmpresa"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import config          from "@/config";
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "EmpresaList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      empresas:       [],
      datoEmpresa:    {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
      localidads:     [],
      tipoIdens:      [],
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Documento",    field: "documento"    },
        { label: "Nombre Corto", field: "nombreCorto"  },
        { label: "Razón Social", field: "razonSocial"  },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
    this.fetchLocalidads();
    this.fetchTipoIdens();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwempresas")
        .then(r => { this.empresas = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar empresas:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwempresas/nombre/" + nombre)
        .then(r => { this.empresas = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar empresa:", e));
    },

    // ── Fetch auxiliares (usando fetch + config igual que el original) ─
    fetchLocalidads() {
      fetch(config.apiBaseUrl + "/vwlocalidads")
        .then(r => r.json())
        .then(data => { this.localidads = data; })
        .catch(e => console.error("Error fetching localidads:", e));
    },

    fetchTipoIdens() {
      fetch(config.apiBaseUrl + "/vwtipoidens")
        .then(r => r.json())
        .then(data => { this.tipoIdens = data; })
        .catch(e => console.error("Error fetching tipoIdens:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoEmpresa,
        ["idLocalidad", "idTipoIden", "documento", "razonSocial", "nombre", "nombreCorto", "direccion"],
        ["Localidad", "Tipo Identificación", "Documento", "Razón Social", "Nombre", "Nombre Corto", "Dirección"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarEmpresa() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoEmpresa.idUsuarioReg = window.sessionStorage.getItem("idUsuario");
        await api.post("/empresas", this.datoEmpresa);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Empresa creada exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarEmpresa() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoEmpresa.idUsuarioAct = window.sessionStorage.getItem("idUsuario");
        await api.post("/empresas", this.datoEmpresa);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Empresa actualizada exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteEmpresa(idEmpresa) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar empresa?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/empresas/" + idEmpresa);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoEmpresa = {};
      this.titulo      = "Crear Empresa";
      this.btnCrear    = true;
      this.btnEditar   = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idEmpresa) {
      this.modalWindow = true;
      this.titulo      = "Editar Empresa";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp       = await api.get("/vwempresas/" + idEmpresa);
        this.datoEmpresa = resp.data;
      } catch (e) {
        console.error("Error al cargar empresa:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idEmpresa) {
      if (idEmpresa != null) this.$router.push("/empresaform/" + idEmpresa);
    },
  },
};
</script>